export enum LikeNodeType {
	ArticleCard,
	Outfit,
	OutfitCard,
	Product,
	ProductCard,
	ProductSearch,
	ProductsYouMayAlsoLike,
	WardrobeItemCard,
	WardrobeItemSearch,
	Wishlist,
	UserFeed,
	ArticleComment,
}
